import React from 'react';

import { Text } from '@mantine/core';
import cx from 'classnames';

import formatDate from '@/utils/formatDate';

import styles from './cells.module.scss';

interface TransmissionDateCellProps {
  transmissionAt: string | null;
}

export const TransmissionDateCell: React.FC<TransmissionDateCellProps> = ({ transmissionAt }) => {
  const displayDate = transmissionAt ? formatDate(transmissionAt, 'MM-DD-YYYY') : 'N/A';
  return <Text className={cx(styles.transmissionDate, styles.cellText)}>{displayDate}</Text>;
};
